import React from 'react';
import css from './SupplierEnquiryForm.module.css';
import Button from '../../Button/Button';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from '../../../util/reactIntl';
import { createSlug } from '../../../util/urlHelpers';

const SupplierEnquiryFormComponent = ({
  currentListing,
  currentUser,
  history,
  disabled,
}) => {
  if (!currentListing?.id?.uuid) return null;

  const handleClick = () => {
    const listingId = currentListing.id.uuid;
    const listingTitle = currentListing.attributes?.title || '';
    const slug = createSlug(listingTitle);

    // Navigate to the ContactSupplierPage
    history.push(`/l/${slug}/${listingId}/contact-supplier`);
  };

  return (
    <div className={css.wrapper}>
      <Button type="button" onClick={handleClick} disabled={disabled}>
        <FormattedMessage id="SupplierEnquiryForm.sendMessage" />
      </Button>
    </div>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    currentUser,
  };
};

const SupplierEnquiryForm = compose(
  connect(mapStateToProps),
  withRouter
)(SupplierEnquiryFormComponent);

export default SupplierEnquiryForm;
